import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

// Import components
import errors from './modules/errors'
import management from './modules/management'
import shared from './modules/shared'
import core from './modules/core'
import comceptum from './modules/comceptum'
import carpetline from './modules/carpetline'
import fm from './modules/fm'
import fmmodule from './modules/fmmodule'
import fmwebapp from './modules/fmwebapp'

Vue.use(Vuex)

let debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    'errors' : errors,
    'management': management,
    'shared': shared,
    'core': core,
    'comceptum': comceptum,
    'carpetline': carpetline,
    'fm': fm,
    'fmmodule': fmmodule,
    'fmwebapp': fmwebapp
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
